import type { SessionConfig } from '@xing-com/crate-xinglet/internal';

import type { ConfigureResponse } from '../types';

const AUTH_STATE_HEADER = 'XING-ONE-AUTHENTICATION-STATE';

const kebabify = (value: string | null): string => {
  return String(value || '')
    .toLowerCase()
    .replace(/_/g, '-');
};

function reload(): void {
  window.document.location.reload();
}

export function configureResponseWithAuthCheck(
  sessionConfig: SessionConfig
): ConfigureResponse {
  return (response) => {
    const { loginState } = sessionConfig;
    const hopsAuthState = kebabify(loginState);
    const xingOneAuthState = kebabify(response.headers.get(AUTH_STATE_HEADER));

    if (
      hopsAuthState &&
      xingOneAuthState &&
      hopsAuthState !== xingOneAuthState
    ) {
      reload();
    }

    return response;
  };
}
